import { render, staticRenderFns } from "./OracleSlider.vue?vue&type=template&id=330fb35a&scoped=true&"
import script from "./OracleSlider.vue?vue&type=script&lang=js&"
export * from "./OracleSlider.vue?vue&type=script&lang=js&"
import style0 from "./OracleSlider.vue?vue&type=style&index=0&id=330fb35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330fb35a",
  null
  
)

component.options.__file = "OracleSlider.vue"
export default component.exports